import React, { useEffect, useMemo } from "react";
import Lottie from "lottie-react";
import qrBox from "assets/images/big box.svg";
import logoEgizio from "assets/images/logoMEgizio.svg";
import { animated } from "react-spring";
import useTextFadeSwitcher from "hooks/useTextFadeSwitcher";
import { useScribeContext } from "../../contexts/scribe/scribe-provider";
import AnimatedAccessories from "../accessories/AnimatedAccessories";
import { useAppContext } from "../../AppContext";
import QRCode from "qrcode.react";


const qrBoxScaleBase = 1.8;

const QRCodeAccessoriesCode: React.FC = () => {
    const [scale, setScale] = React.useState<number>(qrBoxScaleBase);
    const [qrCodeBoxPosition, setQrCodeBoxPosition] = React.useState<number>(0);
    const { switchToQrCodeScribe, setShowQrCode, showQrCode } = useScribeContext();
    const [isReadyForAnimation, setIsReadyForAnimation] = React.useState<boolean>(false); // Stato per controllare l'animazione
    const shopURL = "https://www.museoegizio.it/";
    //    const shopURL = "https://yourname.museoegizio.it/";

    // Calculate and set the scale and position
    useEffect(() => {
        const scribeLoopAnimationElement = document.getElementById(
            "scribe-loop-animation"
        );

        if (scribeLoopAnimationElement) {
            const rect = scribeLoopAnimationElement.getBoundingClientRect();
            setScale(() => rect.width / 800 * qrBoxScaleBase);
            setQrCodeBoxPosition(() => rect.height + 15);
        }
    }, [ switchToQrCodeScribe, setScale, setQrCodeBoxPosition]);

    useEffect(() => {
        // Delay animation readiness to ensure transitions are applied
        const timerId = setTimeout(() => {
            setIsReadyForAnimation(true);
        }, 50); // Ritardo breve per attivare la transizione
        return () => clearTimeout(timerId);
    }, []);


    const currentURL = useMemo(() => `https://www.museoegizio.it/`, []);

    const {
        text: textTitle,
        fadeProps: fadePropsTitle,
        textStyle: titleStyle,
    } = useTextFadeSwitcher(
        "ACQUISTA </BR> IL CARTIGLIO </BR> CON IL TUO NOME",
        "BUY </BR> THE CARTOUCHE </BR> WITH YOUR NAME",
        3000,
        "40px",
        "1.1",
        "#AD8B19"
    );

    const {
        text: textSub,
        fadeProps: fadePropsSub,
        textStyle: subStyle,
    } = useTextFadeSwitcher(
        "INQUADRA IL QR CODE",
        "SCAN THE QR CODE",
        3000,
        "35px",
        "0.5",
        "#ffffff"
    );

    // Show QR Code after a delay
    useEffect(() => {
        if (showQrCode) return;

        const timerId = setTimeout(() => {
            setShowQrCode(true);
        }, 2000);

        return () => clearTimeout(timerId);
    }, [showQrCode, setShowQrCode]);

    return (
        <>
            {switchToQrCodeScribe && (
                <div className="relative height-100 scribe-loop-animation"  >
                    {scale !== null && (
                        <div
                            className="flex justify-center align-center"

                            style={{
                                transform: showQrCode
                                    ? `scale(${scale}) translateY(0)`
                                    : `scale(${scale}) translateY(50px)`,
                                transition: "transform 1s ease,  opacity 0.5s ease",
                                opacity: showQrCode ? "1" : "0",
                                bottom: `${qrCodeBoxPosition}px`,
                                position: "absolute",
                                marginLeft: "90px",
                            }}
                        >
                            <img

                                src={qrBox}
                                alt="error loading page. please refresh!"
                                className={
                                    window.innerWidth > 1140 && window.innerWidth < 1635
                                        ? "qr-code-text center"
                                        : window.innerWidth <= 1140
                                            ? "origin-bottom-left"
                                            : "origin-bottom-right"
                                }
                                style={{
                                    filter: "drop-shadow(0 0 50px rgba(255, 215, 215, 1))",
                                }}
                            />
                            <div className="absolute top-0 left-0 right-0 flex direction-column align-center">
                                <QRCode
                                    value={shopURL}
                                    className="scale-qr"
                                    style={{ marginTop: "45px" }}
                                    level="H"
                                />
                                <div
                                    className="flex direction-column justify-center align-center gap-10"
                                    style={{ marginTop: "30px" }}
                                >
                                    <animated.div
                                        style={{
                                            ...fadePropsTitle,
                                            ...titleStyle,
                                            textAlign: "center",
                                            color: "#AD8B19",
                                            fontWeight: "bold",
                                        }}
                                        className="qr-code-text"
                                        dangerouslySetInnerHTML={{
                                            __html: textTitle,
                                        }}
                                    />
                                    <animated.div
                                        style={{
                                            ...fadePropsSub,
                                            ...subStyle,
                                            textAlign: "center",
                                            color: "#ffffff",

                                        }}
                                        className={"qr-code-museum-text"}
                                        dangerouslySetInnerHTML={{
                                            __html: textSub,
                                        }}
                                    />
                                </div>
                            </div>
                        </div>
                    )}

                    <animated.div
                        className="absolute bottom-0"
                        style={{
                            transition: isReadyForAnimation
                                ? "transform 3s ease, opacity 2s ease"
                                : "none", // Nessuna transizione iniziale
                            opacity: showQrCode ? "1" : "0",
                            transform: showQrCode
                                ? "translateY(0)"
                                : "translateY(70px)",
                            marginLeft: "45px",
                            scale: "1.05" ,
                            marginBottom: "20px",
                        }}
                    >
                        <AnimatedAccessories />
                    </animated.div>
                </div>
            )}
        </>
    );
};

export default QRCodeAccessoriesCode;
